import { useEffect, useState } from "react";
import AdsHeader from "@/components/ads/AdsHeader";
import AdsHero from "@/components/ads/AdsHero";
import AdsModeSelector from "@/components/ads/AdsModeSelector";
import type { AdsMode } from "@/components/ads/AdsModeSelector";
import AdsCompetitiveStory from "@/components/ads/AdsCompetitiveStory";
import AdsCallTest from "@/components/ads/AdsCallTest";
import AdsValueStrip from "@/components/ads/AdsValueStrip";
import AdsDashboardMockup from "@/components/ads/AdsDashboardMockup";
import AdsROISlider from "@/components/ads/AdsROISlider";
import AdsHowItWorks from "@/components/ads/AdsHowItWorks";
import AdsDifferentiation from "@/components/ads/AdsDifferentiation";
import AdsSocialProof from "@/components/ads/AdsSocialProof";
import AdsPricing from "@/components/ads/AdsPricing";
import AdsFAQ from "@/components/ads/AdsFAQ";
import AdsCTA from "@/components/ads/AdsCTA";
import AdsFooter from "@/components/ads/AdsFooter";
import AdsStickyBar from "@/components/ads/AdsStickyBar";
import { SectionTracker } from "@/components/landing/SectionTracker";
import { trackEvent } from "@/lib/analytics";
import SEOHead from "@/components/SEOHead";

const AdsLanding = () => {
  const [mode, setMode] = useState<AdsMode>("vente");

  useEffect(() => {

    trackEvent("lp_offre2026_page_view", {
      event_category: "lp_offre_2026",
      page_path: "/landing-immovox-offre-2026",
    });

    const startTime = Date.now();
    const handleUnload = () => {
      const timeSpentSec = Math.round((Date.now() - startTime) / 1000);
      trackEvent("lp_offre2026_time_on_page", {
        event_category: "lp_offre_2026",
        time_spent_seconds: timeSpentSec,
      });
    };
    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      handleUnload();
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Immovox – Chaque appel non décroché a un prix"
        description="Vente ou location, Immovox qualifie les appels immobiliers et transmet une fiche exploitable à votre équipe."
        canonical="/landing-immovox-offre-2026"
        robots="noindex,follow"
      />
      <AdsHeader mode={mode} onModeChange={setMode} />

      <SectionTracker name="lp_offre2026_hero">
        <AdsHero mode={mode} onModeChange={setMode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_value_strip">
        <AdsValueStrip mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_call_test">
        <AdsCallTest mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_competitive_story">
        <AdsCompetitiveStory mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_dashboard_mockup">
        <AdsDashboardMockup mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_roi_slider">
        <AdsROISlider mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_how_it_works">
        <AdsHowItWorks mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_differentiation">
        <AdsDifferentiation mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_social_proof">
        <AdsSocialProof mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_pricing">
        <AdsPricing mode={mode} />
      </SectionTracker>

      <SectionTracker name="lp_offre2026_faq">
        <AdsFAQ mode={mode} />
      </SectionTracker>

      <AdsCTA mode={mode} />
      <AdsFooter />
      <AdsStickyBar mode={mode} />
    </div>
  );
};

export default AdsLanding;
